import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import {
  getSelectedProductSubscriptionId,
  getCurrentProductSubscriptionDetail,
} from "shared/utility/ProductSubscriptionHelper";
import { getSubscription } from "store/slices/SubscriptionSlice";
import Subscription from "interfaces/response/Subscription";

export const useSubscriptionsLoader = (
  forceLoad: boolean = true
): [Subscription | null, boolean] => {
  const dispatch: AppDispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isDataLoaderExecuted, setIsDataLoaderExecuted] = useState(false);
  const [data, setData] = useState<Subscription | null>(null);

  const currentSubscriptionDetail = useSelector((state: RootState) =>
    getCurrentProductSubscriptionDetail(state)
  );

  const currentProductSubscriptionId = useSelector((state: RootState) =>
    getSelectedProductSubscriptionId(state)
  );

  useEffect(() => {
    // We will load subscriptions if, subscriptions are not loaded yet or forceLoad is set to true.
    // Because of dependencies of this useEffect, it may called multiple times. Wee need to
    // guard repeated data loading by setting a flag isDataLoaderExecuted.
    if (
      !isDataLoaderExecuted &&
      (forceLoad || !currentSubscriptionDetail?.id) &&
      currentProductSubscriptionId
    ) {
      setLoading(true);
      // We will execute subscription data loading only once.
      setIsDataLoaderExecuted(true);
      dispatch(getSubscription(currentProductSubscriptionId)).then(() => {
        setLoading(false);
      });
    }
  }, [
    forceLoad,
    currentSubscriptionDetail?.id,
    currentProductSubscriptionId,
    isDataLoaderExecuted,
    dispatch,
  ]);

  useEffect(() => {
    setData(currentSubscriptionDetail);
  }, [currentSubscriptionDetail]);

  return [data, loading];
};
